export default __webpack_public_path__ + "static/media/logo-white.09dfd745.svg";